import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation, Link } from "react-router-dom"
import PropTypes from "prop-types"
import { PERMISSION } from "common/permission";
import { getPermission, getUser, uId } from "common/utility";
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import { adminRoutes } from "../../routes/admin"
import { customerRoutes } from "../../routes/customer"

const renderSubMenu = (submenu, props) => (
  <ul className="sub-menu">
    {submenu.map((subnav, j) => (
      <React.Fragment key={`__nestedmenu__${j}`}>
        {!subnav.hideMenu && (
          <li>
            {subnav.submenu && subnav.submenu.length > 0 ? (
              <Link to="#" className="disabled-link">
                {props.t(subnav.displayName)}
              </Link>
            ) : (
              <Link to={subnav.path}>{props.t(subnav.displayName)}</Link>
            )}
            {subnav.submenu &&
              subnav.submenu.length > 0 &&
              renderSubMenu(subnav.submenu, props)}
          </li>
        )}
      </React.Fragment>
    ))}
  </ul>
);


const SidebarContent = props => {
  const ref = useRef()
  const [routes, setRoutes] = useState([]);
  const activateParentDropdown = useCallback(item => {
    const addClassRecursively = (element, className) => {
      if (element) {
        element.classList.add(className);
        addClassRecursively(element.parentElement, "mm-show");
      }
    };

    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent?.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      addClassRecursively(parent.parentElement, "mm-show");
    }

    scrollElement(item);
    return false;
  }, []);


  const removeActivation = items => {
    const removeClassRecursively = (element, className) => {
      if (element) {
        element.classList.remove(className);
        removeClassRecursively(element.parentElement, "mm-show");
      }
    };

    for (const item of items) {
      const parent = item.parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }

      if (parent) {
        const parent2El = parent.childNodes && parent.childNodes.length && parent.childNodes[1];
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        removeClassRecursively(parent.parentElement, "mm-show");
      }
    }
  };


  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (const item of items) {
      if (pathName === item.pathname) {
        matchingMenuItem = item;
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
    fetchPermissions();
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const menuListWithIcon = (nav, index) => {
    return (
      <li key={uId()}>
        <Link to={nav.path} style={{ fontSize: '0.9rem', fontWeight: '500' }}>
          <i className={nav.icon}></i>
          <span>{props.t(nav.displayName)}</span>
        </Link>
      </li>
    )
  }

  const fetchPermissions = async () => {
    const rolesPermission = await getPermission();

    const roleName = await getUser('roleName');
    let rouList = []
    if (roleName == 'dealer') {
      rouList = customerRoutes
    } else {
      rouList = adminRoutes(roleName) || []
    }
    const allRouters = Object.assign([...rouList]);
    const cloneRouter = allRouters.map((r) => {
      if (r.submenu?.length > 0) {
        return { ...r, submenu: [...r.submenu] };
      } else return { ...r };
    });
    const allRoutes = chechMenuPermission(rolesPermission, cloneRouter);
    setRoutes(allRoutes);
  };

  const chechMenuPermission = (rolesPermission, routerList) => {
    return (
      routerList
        .filter((r) => !r.hideMenu)
        .filter((route) => {
          let isPagePermission = false;
          if (route.submenu?.length > 0) {
            const submenu = chechMenuPermission(rolesPermission, route.submenu);
            route.submenu = submenu;
            isPagePermission = submenu?.length > 0;
          } else {
            const { permission, action } = route;
            if (!permission || !action) {
              return true
            }
            isPagePermission = isMenuPermissionExist(
              rolesPermission,
              permission,
              action
            );
          }
          return isPagePermission;
        }) || []
    );
  };

  const isMenuPermissionExist = (rolesPermission, permission, action) => {
    const pagePermission = rolesPermission.find(
      (p) => p.permission_name === permission
    );
    return (
      pagePermission &&
      (pagePermission[action] == PERMISSION.PERMISSION_STATUS.ALLOWED ||
        pagePermission[action] ===
          PERMISSION.PERMISSION_STATUS.SOME_OTHER_STATUS)
    );
  };

  return (
    <React.Fragment>
      <SimpleBar className="" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {routes.map(
              (nav, i) =>
                !nav.hideMenu &&
                (!Object.hasOwn(nav, "submenu") ? (
                  menuListWithIcon(nav, `__parentmanu__${i}`)
                ) : (
                  <li key={"__parentnestedmenu__" + uId()}>
                    <a style={{ fontSize: '0.9rem', fontWeight: '600' }} href="#" className="has-arrow">
                      <i className={nav.icon}></i>
                      <span>{props.t(nav.displayName)}</span>
                    </a>
                    {nav.submenu &&
                      nav.submenu.length > 0 &&
                      renderSubMenu(nav.submenu, props)}
                  </li>
                ))
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
